export default [
    {
        id: 1,
        name_ca: 'Estar (E)',
        name_en: 'Living (E)',
        name_es: 'Estar (E)',
        code_ca: 'E'
    },
    {
        id: 2,
        name_ca: 'Estar / Menjador (E-M)',
        name_en: 'Living / Dinning (L-D)',
        name_es: 'Estar / Comedor (E-C)',
        code_ca: 'E-M'
    },
    {
        id: 3,
        name_ca: 'Estar / Menjador / Cuina (E-M-C)',
        name_en: 'Living / Dinning / Kitchen (L-D-K)',
        name_es: 'Estar / Comedor / Cocina',
        code_ca: 'E-M-C'
    },
    {
        id: 4,
        name_ca: 'Menjador (M)',
        name_en: 'Dinning (D)',
        name_es: 'Comedor (C)',
        code_ca: 'M'
    },
    {
        id: 5,
        name_ca: 'Cuina (C)',
        name_en: 'Kitchen (K)',
        name_es: 'Cocina (C)',
        code_ca: 'C'
    },
    {
        id: 6,
        name_ca: 'Habitació (H)',
        name_en: 'Room (R)',
        name_es: 'Habitación (H)',
        code_ca: 'H'
    },
    {
        id: 7,
        name_ca: 'Cambra Higiènica (CH)',
        name_en: 'Bathroom (B)',
        name_es: 'Baño (B)',
        code_ca: 'CH'
    },
    {
        id: 8,
        name_ca: 'Emmagatzematge Personal (EP)',
        name_en: 'Personal Storage (PS)',
        name_es: 'Almacenamiento Personal (AP)',
        code_ca: 'EP'
    },
    {
        id: 9,
        name_ca: 'Emmagatzematge General (EG)',
        name_en: 'General Storage (GS)',
        name_es: 'Almacenamiento General (AG)',
        code_ca: 'EG'
    },
    {
        id: 10,
        name_ca: 'Espais intermedis amb l\'exterior (EI)',
        name_en: 'Indoor-Outdoor intermediate spaces (IS)',
        name_es: 'Espacios intermedios con el exterior (EI)',
        code_ca: 'EI'
    },
    {
        id: 11,
        name_ca: 'Altres (A)',
        name_en: 'Others (O)',
        name_es: 'Otros (O)',
        code_ca: 'A'
    }
]



// WEBPACK FOOTER //
// ./src/options/room_types.js